import React from 'react'

import MaintenanceScreen from '@/components/maintenance/MaintenanceScreen'

// it is outside all provider, if you need any provider,
// you need to add it to wrap this component
const Maintenance = () => <MaintenanceScreen />

export default Maintenance
